module.exports = __webpack_public_path__ + "static/cercazone_nordovest3-2e68bfc5d834c7b8f07447581b0783a6.jpg";